import { render, staticRenderFns } from "./wysiwygComponent.vue?vue&type=template&id=3b209e7c&scoped=true&"
import script from "./wysiwygComponent.vue?vue&type=script&lang=js&"
export * from "./wysiwygComponent.vue?vue&type=script&lang=js&"
import style0 from "./wysiwygComponent.vue?vue&type=style&index=0&id=3b209e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b209e7c",
  null
  
)

export default component.exports